// src/storefront/StoreNotFound.tsx
export default function StoreNotFound() {
    return (
      <div style={{ padding: 24 }}>
        <h1>Store not found</h1>
        <p>Bu domain için mağaza kaydı bulunamadı.</p>
      </div>
    );
  }